export const getElevator = (elevator) => {
  switch (elevator) {
    case 0:
      return 'אין מעלית';
    case 1:
      return 'מעלית קיימת';
    default:
      return '';
  }
};